import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Message from '@/pages/Pro/MessageTrace/MessageList/Message';

function Item({ info, currentTopic }) {
  if (info.messageId) {
    const [ledgerId, entryId, partitionIndex, batchIndex] = info.messageId.split(':');

    return (
      <Root>
        <span style={{ paddingRight: 5 }}>接收到消息：{info.txt}</span>
        <Message
          clusterName={currentTopic.clusterName}
          row={{
            topic: currentTopic.fullTopicName,
            batchIndex,
            partition: partitionIndex,
            messageId: `${ledgerId}:${entryId}`,
            linkText: '[查看消息轨迹]',
          }}
        />
      </Root>
    );
  }
  return <div>{info.txt}</div>;
}

export default connect((state) => ({
  currentTopic: state.messageSAR.currentTopic,
}))(Item);

const Root = styled.div`
  .t-link {
    color: rgb(105, 152, 255);
    font-size: 12px;
    line-height: 18px;
  }
`;
